var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayShowAll)?_c('b-nav-item',{staticClass:"navclickable nav-item-indented",on:{"click":function($event){_vm.showAll = true}}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"text-truncate",attrs:{"cols":"11"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('TL_LEFT_SIDEBAR_SHOW_ALL', {
            itemcount: _vm.itemcount,
            title: _vm.title,
          }))+"\n      ")])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }